import './outline-button.scss';

import { FC, ReactNode } from 'react';

interface OutlineButtonProps {
  children: ReactNode;
  onClick?: () => void;
  ariaLabel?: string;
  tabIndex?: number;
  icon?: ReactNode;
}

const OutlineButton: FC<OutlineButtonProps> = ({
  children,
  onClick,
  icon,
  ariaLabel,
  tabIndex,
}: OutlineButtonProps) => {
  return (
    <button
      onClick={onClick}
      tabIndex={tabIndex}
      role="button"
      aria-label={ariaLabel}
      className="outline-button"
      data-testid="outline-button"
    >
      {icon && <div className="outline-button__icon">{icon}</div>} {children}
    </button>
  );
};

OutlineButton.defaultProps = {
  icon: null,
  onClick: () => {
    /* do nothing */
  },
};

export default OutlineButton;
